import { ProfileAvatar } from "./ProfileAvatar";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Group, Text, UnstyledButton } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { brandColorTokens } from "../theme/brandColorTokens";
import classes from "./ProductPageHeader.module.css";
import { productMenuTriggerProps, productMenuIconProps, productMenuLabelClassName } from "../theme/productChrome";

type Props = ComponentPropsWithoutRef<"button"> & {
  displayName: string;
  avatarName: string | null | undefined;
  avatar?: string;
  email?: string | null;
};

/** Shared identity trigger; each product owns its account actions and avatar source. */
export const ProductUserMenuTrigger = forwardRef<HTMLButtonElement, Props>(function ProductUserMenuTrigger(
  { displayName, avatarName, avatar, email, className, ...props },
  ref,
) {
  return (
    <UnstyledButton
      ref={ref}
      {...productMenuTriggerProps}
      {...props}
      className={[productMenuTriggerProps.className, className].filter(Boolean).join(" ")}
    >
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Group gap="sm" wrap="nowrap" className={classes.heading}>
          <ProfileAvatar src={avatar} name={avatarName} email={email} alt={displayName} size={24} />
          <Text
            size="sm"
            fw={600}
            truncate
            className={productMenuLabelClassName}
            title={displayName}
            c={brandColorTokens.bodyText}
          >
            {displayName}
          </Text>
        </Group>
        <IconDotsVertical {...productMenuIconProps} />
      </Group>
    </UnstyledButton>
  );
});
